import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {createJSONSchemaProtectora} from "../schema_org_helper";
import {PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN} from "../../../../../App/RouterAdopta";

class ItemList_Schema_org extends Component {
    
    constructor(props, context) {
        super(props, context);
        
        this.createItemList = this.createItemList.bind(this);
        this.createJSONSchema = this.createJSONSchema.bind(this);
        
    }
    
    
    createItemList() {
        
        return this.props.itemList?.map((item, index) => {
            if(item?.tipo === "protectora"){
                const schema =  createJSONSchemaProtectora(item,this.props.HOST, PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN);
                schema.position = index+1
                return schema
            }
        })
    }
    
    createJSONSchema() {
        return {
            "@context": "https://schema.org",
            "@type": "ItemList",
            "itemListElement": this.createItemList()
        }
    }
    
    render() {
        return (
            <Helmet>
                <script id="srp_faq" type="application/ld+json">
                    {JSON.stringify(this.createJSONSchema())}
                </script>
            </Helmet>
        );
    }
    
    componentWillMount() {
    
    }
    
    componentDidMount() {
    
    
    }
    
    componentDidUpdate() {
    
    }
    
    
}

export default ItemList_Schema_org
